module.exports = __webpack_public_path__ + "img/fail1.1d013a42.png";